import React from 'react'
import AsSeenIn from './as-seen-in'
import { ScrollFadeIn } from '../../../components/ScrollFadeIn'
import Container from '../components/Container'
import GetStartedButton from '../components/GetStartedButton'

const Hero = () => {
    return (
        <Container>
            <ScrollFadeIn className=" ">
                {/* Desktop */}
                <div className="hidden md:flex mb-24 space-x-10">
                    <div className="sm:w-1/2">
                        <h1 className="font-times font-[200] text-3xl sm:text-4xl tracking-wide lg:text-5xl 2xl:text-7xl 2xl:leading-[90px] text-gray-800 max-w-md sm:max-w-none">
                            <span aria-label="Advice-Only Financial Planning">Advice-Only Financial Planning</span>
                        </h1>
                        <h1 className="font-times font-[200] text-3xl sm:text-4xl tracking-wide lg:text-5xl 2xl:text-7xl 2xl:leading-[90px] text-gray-800 max-w-md sm:max-w-none">
                            <span aria-label="For Everyone">
                                For <span className='lato font-bold text-secondary-500'>Everyone</span>
                            </span>
                        </h1>
                        <ul className="list-disc ml-7 py-5 lg:py-7 mb-2 text-lg sm:text-xl lg:text-2xl text-gray-600 font-lato" aria-label="Benefits">
                            <li>Only Pay For Advice</li>
                            <li>Keep MORE of Your Money</li>
                            <li>No Sales Pitches Or Hidden Fees Ever!</li>
                        </ul>
                        <GetStartedButton id='home-page-hero' />
                    </div>
                    <div className="sm:w-1/2">
                        <img
                            src="https://res.cloudinary.com/abundo-wealth-assets/image/upload/v1718142821/Abundo%20Wealth%20Assets/pages/public-home/HomepageMotherDaughter2_vlhoga_2_wylukd.webp"
                            alt="Smiling blonde woman holding a young girl with pigtails as they touch noses affectionately."
                            className='object-cover rounded-2xl h-[300px] sm:h-[400px] lg:h-[535px] w-full shadow-md'
                        />
                    </div>
                </div>
                {/* Mobile */}
                <div className="md:hidden mb-16 space-y-10 flex flex-col">
                    <div className="">
                        <div className="text-4xl xs:text-5xl space-y-1 xs:space-y-3 sm:space-y-0 font-[200] tracking-wide max-w-md">
                            <h1 className="font-times text-gray-800" aria-label="Advice-Only Financial Planning">
                                Advice-Only Financial Planning
                            </h1>
                            <h1 className="lato font-bold text-gray-800" aria-label="For Everyone">
                                For <span className='text-secondary-500'>Everyone</span>
                            </h1>
                        </div>
                        <ul className="font-[600] list-disc ml-7 py-5 lg:py-7 mb-2 text-lg sm:text-xl lg:text-2xl text-gray-600 font-lato" aria-label="Benefits">
                            <li>Only Pay For Advice</li>
                            <li>Keep MORE of Your Money</li>
                            <li>No Sales Pitches Or Hidden Fees Ever!</li>
                        </ul>
                        <div className="">
                            <GetStartedButton id='home-page-hero' />
                        </div>
                    </div>
                    <div className="">
                        <img
                            src="https://res.cloudinary.com/abundo-wealth-assets/image/upload/v1718142821/Abundo%20Wealth%20Assets/pages/public-home/HomepageMotherDaughter2_vlhoga_2_wylukd.webp"
                            alt="Smiling blonde woman holding a young girl with pigtails as they touch noses affectionately."
                            className='object-cover rounded-2xl h-[300px] mx-auto w-full shadow-lg'
                        />
                    </div>
                </div>
            </ScrollFadeIn>
            <AsSeenIn />
        </Container>
    )
}

export default Hero